import React, { useEffect, useState } from "react";

import { Box, Typography, Button, TextField, CircularProgress, Card, CardContent, Alert, useTheme } from "@mui/material";

import { useParams, Link } from "react-router-dom";
import { getNameByUserId, sendMessageToUser } from "../services/ApiService";
import { useTranslation } from "react-i18next";

const SecretById = () => {
  const theme = useTheme();
  const { id, lang } = useParams();
  const UserId = id;
  // const UserId = localStorage.getItem("userId");
  const [name, setName] = useState("");
  const [thought, setThought] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || "en";

  useEffect(() => {
    console.log(currentLang);
  }, [currentLang]);
  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const userName = await getNameByUserId(UserId);
        setName(userName);
      } catch (error) {
        setError(error.message);
      }
    };

    if (UserId) {
      fetchUserName();
    }
  }, [UserId]);

  const handleSendMessage = async () => {
    if (!thought.trim()) {
      setError(t("secretById.errors.thoughtRequired"));
      return;
    }

    setError("");
    setSuccess(false);
    setLoading(true);

    try {
      await sendMessageToUser(UserId, thought);
      setSuccess(true);
      setThought("");
    } catch (error) {
      setError(t("secretById.errors.generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ mt: 4, px: 2 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        color="#fff"
        sx={{ color: "text.primary", textAlign: "center", fontSize: { xs: "1.4rem", sm: "2rem", md: "2.5rem" } }}>
        {t("secretById.title")} {name || t('secretById.anonymousUser')}
      </Typography>
      <Card
        sx={{
          width: "100%",
          maxWidth: { xs: "95vw", sm: "90vw", md: 800 }, // Adjust only for xs and sm
          p: { xs: 2, sm: 3, md: 4 }, // Adjust padding only for xs/sm
          mt: { xs: 3, sm: 6, md: 8 },
          mb: { xs: 4, sm: 8 },
          boxShadow: 4,
          borderRadius: 2,

          color: "text.primary"
        }}>
        <CardContent>
          {success ? (
            <Box textAlign="center">
              <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ fontSize: { xs: "2rem", sm: "2rem", md: "2.5rem" } }}>
                {t('secretById.thankYouTitle', 'Thanks For Your Participation!')}
              </Typography>
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  color: theme.palette.mode === "dark" ? theme.palette.text.successDark : theme.palette.text.successLight,
                  fontSize: { xs: "1rem", sm: "1.3rem", md: "1.5rem" }
                }}>
                {t("secretById.successMessage")}
              </Typography>
              <Typography variant="h6" gutterBottom>
                {t("secretById.createYourOwn")}
              </Typography>
              <Button
                onClick={() => (window.location.href = `/${currentLang}`)}
                variant="contained"
                sx={{
                  ...theme.components.MuiButton.styleOverrides.linkButton // Get from theme
                }}>
                {t("secretMessage.title")}
              </Button>
            </Box>
          ) : (
            <Box>
              <Box mb={3}>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {t('secretById.instructions.step1', { name: name || t('secretById.anonymousUser') })}
                </Typography>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {t('secretById.instructions.step2', { name: name || t('secretById.anonymousUser') })}
                </Typography>
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {t('secretById.instructions.step3', { name: name || t('secretById.anonymousUser') })}
                </Typography>
              </Box>

              <TextField
                fullWidth
                value={thought}
                onChange={e => setThought(e.target.value)}
                placeholder={t("secretById.thoughtField")}
                variant="outlined"
                multiline
                rows={4}
              />

              {error && (
                <Alert severity="error" sx={{ mb: 3, textAlign: "center" }}>
                  {error}
                </Alert>
              )}

              <Button
                onClick={handleSendMessage}
                disabled={loading}
                variant="contained"
                size="large"
                fullWidth
                sx={{
                  mt: 2,
                  py: 2,

                  fontSize: 20,
                  fontWeight: "bold"
                }}>
                {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : t("secretById.sendButton")}
              </Button>
              <Link
                to={`/${currentLang}`}
                style={{
                  ...theme.components.linkgen // Get from theme
                }}>
                {t("secretById.createYourOwn")}
              </Link>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default SecretById;
